import styled from 'styled-components';


export const StdButton = styled.div`
  width: 100%;
  float: left;
  text-align: center;
`;

export const StdBox = styled.button.withConfig({ 
  shouldForwardProp: (prop) => 
    !['backColor', 'hoverColor', 'borderColor'].includes(prop),
})
  `
  cursor: pointer;
  position: relative;
  display: inline-flex;
  text-align: center;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  min-height: 44px;
  min-width: 44px;
  padding: 0px 32px;
  border: 2px solid ${props => props.borderColor};
  margin: 0px;
  border-radius: 500px;
  transition: all 0.2s ease-in-out 0s;
  text-decoration: none;
  border: 1px solid  ${props => props.color};
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  background: ${props => props.backColor};
  
  color: ${props => props.color};
  &:hover {    
    background-color: ${props => props.hoverColor};

  }
`;
